import { CopyOutlined } from '@ant-design/icons'
import type { ProRenderFieldPropsType } from '@ant-design/pro-provider'
import { t } from '@lingui/core/macro'
import { type ContactField, getContactHref } from '@pkg/shared/utils/contact.utils'
import { Space, Typography } from 'antd'
import type React from 'react'
import { FaEnvelope, FaMobile, FaPhone, FaPrint } from 'react-icons/fa6'

const contactIcons: Record<ContactField, React.ReactNode> = {
  phone: <FaPhone className="inline mr-1.5 text-xs text-gray-400" />,
  mobile: <FaMobile className="inline mr-1.5 text-xs text-gray-400" />,
  email: <FaEnvelope className="inline mr-1.5 text-xs text-gray-400" />,
  fax: <FaPrint className="inline mr-1.5 text-xs text-gray-400" />,
}

function createContactLinkValueType(field: ContactField): ProRenderFieldPropsType {
  const icon = contactIcons[field]
  return {
    render: text => {
      const href = getContactHref(field, text)
      return (
        <Typography.Text
          copyable={{
            tooltips: [t`In die Zwischenablage kopieren`, t`In die Zwischenablage kopiert`],
            icon: (
              <>
                <CopyOutlined className="text-neutral-300!" />
                {/*<CheckOutlined />*/}
              </>
            ),
            text,
          }}
        >
          <a href={href} style={{ color: 'inherit' }}>
            <Space>
              {icon}
              {text}
            </Space>
          </a>
        </Typography.Text>
      )
    },
    renderFormItem: () => null,
  }
}

export const phoneLinkValueType = createContactLinkValueType('phone')
export const mobileLinkValueType = createContactLinkValueType('mobile')
export const emailLinkValueType = createContactLinkValueType('email')
export const faxLinkValueType = createContactLinkValueType('fax')
